import { HorizontalBar, mixins } from 'vue-chartjs';
import DefaultOptions from '../DefaultOptions';

export default HorizontalBar.extend({
  mixins: [mixins.reactiveProp],
  props: ['chartOptions'],
  computed: {
    options () {
      return Object.assign({}, DefaultOptions, this.chartOptions);
    },
  },
  mounted () {
    this.renderChart(this.chartData, this.options);
  },
});



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-components/vuestic-chart/chart-types/HorizontalBarChart.js